const GAgendaContainer = () => {
  return (
    <div className="bg-container">
      <iframe
        src="https://calendar.google.com/calendar/embed?height=600&wkst=2&ctz=Europe%2FParis&showPrint=0&mode=WEEK&showTz=0&showTitle=0&src=cm9iaW5hLmxlZ2ltZXRyaWVAZ21haWwuY29t&src=cm9zZW1vcmVhdTEyQGdtYWlsLmNvbQ&src=ZnIuZnJlbmNoI2hvbGlkYXlAZ3JvdXAudi5jYWxlbmRhci5nb29nbGUuY29t&src=YmVydGhlLm1lZGlvdW5pQGdtYWlsLmNvbQ&src=Y2hsZXhwZXJ0aXNlc0BnbWFpbC5jb20&src=ZGFuaWVsLmZldHRvdWhpQGxlZ2ltZXRyaWUuZnI&src=ZWNsZXhwZXJ0aXNlc0Bob3RtYWlsLmNvbQ&src=ZWxpc2ViYXJ0aHByb0BnbWFpbC5jb20&src=ZW1pbGllLnJvaGZyaXRzY2hAZ21haWwuY29t&src=amVzc2ljYUBsZWdpbWV0cmllLmZy&src=c2FpZC5tYWhkaTkyMTIwQGdtYWlsLmNvbQ&src=c3dha2UxM0Bob3RtYWlsLmZy&src=dml0c2VjaEBnbWFpbC5jb20&src=cGFzY2FsQGxlZ2ltZXRyaWUuZnI&color=%23D50000&color=%23D50000&color=%23F6BF26&color=%23D50000&color=%238E24AA&color=%233F51B5&color=%23009688&color=%237CB342&color=%23D50000&color=%239E69AF&color=%23D50000&color=%23D50000&color=%234285F4&color=%23616161"
        style={{
          border: 0,
          width: "100%",
          height: "1000px",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default GAgendaContainer;
